import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
import _ from 'lodash';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { NavLink } from "react-router-dom";

import config from 'config';
import Card from "components/Card/Card.jsx";
import { connect } from 'react-redux';
import reservationActions from 'actions/reservation.actions';
import numeral from 'numeral';
import moment from 'moment-timezone';
//moment.tz.setDefault('America/New_York');

class Reservations extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.fetchDataWithDebounce = _.debounce(this.fetchData, 1000);
    this.state = {
      criteria: {
        limit: config.pageSize,
        offset: 0,
        filtered: "",
        sorted: ""
      }
    };
  }

  componentWillUpdate(props) {
    if(props.error) {
      this.props.addNotification({type: 'error', message: props.error});
    }
  }

  fetchData = (state, instance) => {
    let criteria = this.state.criteria;
    let newFilter = state.filtered.length > 0 ? JSON.stringify(state.filtered) : "";
    let newOrderer = state.sorted.length > 0 ? JSON.stringify(state.sorted) : "";
    if(criteria.filtered !== newFilter) {
      criteria['offset'] = 0;
      criteria['filtered'] = newFilter;
    }
    if(criteria.sorted !== newOrderer) {
      criteria['offset'] = 0;
      criteria['sorted'] = newOrderer;
    }
    if(criteria.limit !== state.pageSize) {
      criteria.limit = state.pageSize;
      criteria['offset'] = 0;
    }
    else {
      criteria['offset'] = Math.ceil(state.page * state.pageSize);
    }
    this.setState({criteria: criteria}, () => {
      this.props.dispatch(reservationActions.getReservations(criteria));
    });
  };

  deleteItem = item => {
    confirmAlert({
      title: 'Delete Reservation',
      message: 'Are you sure you want to delete this reservation?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(reservationActions.delete(item.original.id))
        },
        {
          label: 'No',
          onClick: () => ''
        }
      ]
    });
  }

  render() {
    const reservations = this.props.reservations || [];
    const loading = this.props.loading || false;
    const total = this.props.total || 0;
    const pageCount = Math.ceil(total / this.state.criteria.limit);
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Reservations"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <ReactTable
                    columns={[
                      {
                        Header: "User",
                        accessor: "user",
                        Cell: row => (
                          <NavLink to={"/dashboard/search-reservations?column=firstName&value="+row.original.user.firstName}>{row.original.user.firstName + " " + row.original.user.lastName}</NavLink>
                        )
                      },
                      {
                        Header: "Reservation No.",
                        accessor: "reservationNumber",
                        Cell: row => (config.formatReservationNumber(row.original.reservationNumber)),
                        width: 150
                      },
                      {
                        Header: "Date/Time From",
                        accessor: "slot",
                        width: 300,
                        Cell: row => (
                          <div>{row.original.slot + ' at ' + moment(row.original.depart_stop.time, "HH:mm:ss").format("hh:mm A") + ' from ' + row.original.depart_stop.stop.address}</div>
                        )
                      },
                      {
                        Header: "Seats",
                        accessor: "reservations",
                        Cell: row => (row.original.reservations.length)
                      },
                      {
                        Header: "Seats booked",
                        id: "seatsBooked",
                        accessor: "reservations",
                        width: 150,
                        Cell: function(row) {
                          var res = row.original.reservations || [];
                          var list = res
                            .filter(function(r) { return r.status === 'active'; })
                            .map(function(r) { return r.seat_number != null ? r.seat_number : (r.order_item && r.order_item.seat_number); })
                            .filter(Boolean);
                          return list.length ? list.join(', ') : '—';
                        }
                      },
                      {
                        Header: "Payment Method",
                        accessor: "paymentMethod"
                      },
                      {
                        Header: "Credit Used",
                        accessor: "credit",
                        Cell: row => (numeral(row.original.credit).format('$0.00'))
                      },
                      {
                        Header: "Points Used",
                        accessor: "vouchers"
                      },
                      {
                        Header: "Points Earned (after travel)",
                        accessor: "pointsEarned"
                      }
                    ]}
                    manual
                    data={reservations}
                    pages={pageCount} // Display the total number of pages
                    loading={loading} // Display the loading overlay when we need it
                    onFetchData={this.fetchDataWithDebounce}
                    defaultPageSize={this.state.criteria.limit}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let { items, loading, total, error } = state.reservations;
  return { reservations: items, loading, total, error };
}

export default connect(mapStateToProps)(Reservations);
